import { PLANN3R_COLOR } from '../../constants'
import { Company,
  Employee,
  IntegrationActions,
  MeetingPage,
  MeetingPageFieldType } from '../../types/plann3r'
import {
  CHANGE_ACTION,
  COMPANY_ADD_EMPLOYEE,
  COMPANY_ADD_PAGE,
  COMPANY_DELETE_EMPLOYEE,
  COMPANY_INFO_UPDATE_NAME,
  COMPANY_MAKE_ADMIN,
  COMPANY_SET_AVATAR,
  EDITOR_ADD_DURATION,
  EDITOR_ADD_FIELD,
  EDITOR_DELETE_DURATION,
  EDITOR_REMOVE_FIELD,
  EDITOR_TOGGLE_REQUIRED,
  EDITOR_UPDATE_COPY,
  EDITOR_UPDATE_COPY_PHYSICAL,
  EDITOR_UPDATE_COPY_VIDEOCALL,
  EDITOR_UPDATE_DISPLAY_NAME,
  EDITOR_UPDATE_DURATION,
  EDITOR_UPDATE_DURATION_LABEL,
  EDITOR_UPDATE_LABEL,
  EDITOR_UPDATE_LOCATION,
  EDITOR_UPDATE_LOGO,
  EDITOR_UPDATE_PLACEHOLDER,
  EDITOR_UPDATE_PRIMARY_COLOR,
  EDITOR_UPDATE_SECONDARY_COLOR,
  PAGE_ADD_CALL_OPTION,
  PAGE_ADD_EMPLOYEE,
  PAGE_ADD_OTHER_OFFICE,
  PAGE_CHANGE_CALL_OPTION_TYPE,
  PAGE_CHANGE_CALL_OPTION_VALUE,
  PAGE_CHANGE_OFFICE,
  PAGE_DELETE_EMPLOYEE,
  PAGE_REMOVE_CALL_OPTION,
  PAGE_REMOVE_OFFICE,
  PAGE_SET_BUFFER,
  PAGE_SET_FASTEST_POSSIBLE,
  PAGE_SET_PREFERRED_LANGUAGE,
  PAGE_SET_REQUIRED_EMPLOYEE,
  PAGE_SET_TEMPORARY_END,
  PAGE_SET_TEMPORARY_START,
  PAGE_TOGGLE_AUTO_ACCEPT,
  PAGE_TOGGLE_CALL,
  PAGE_TOGGLE_IGNORE_CALENDARS,
  PAGE_TOGGLE_MY_OFFICE,
  PAGE_TOGGLE_ONE_MOMENT,
  PAGE_TOGGLE_SEQUENTIAL,
  PAGE_TOGGLE_THEIR_OFFICE,
  PAGE_UPDATE_CSS,
  PAGE_UPDATE_GA,
  PAGE_UPDATE_JS,
  PAGE_UPDATE_NAME,
  PAGE_UPDATE_PARTICIPANTS,
  PAGE_UPDATE_PIXEL,
  PAGE_UPDATE_TIMEZONE,
  RECEIVE_COMPANIES,
  REQUEST_COMPANIES,
  SAVED_PAGES,
  SAVING_PAGES,
  SET_ACTIVE_COMPANY,
  SET_ACTIVE_PAGE,
  SET_ACTIVE_TAB,
  SET_LATEST_PAGE,
  PAGE_SET_PREFERRED_TIMES,
} from './actions'
import { PagesManagementActionType, PagesManagementStore } from './types'

const initalState: PagesManagementStore = {
  companies: [],
  isFetching: false,
  active_company: null,
  active_tab: null,
  active_page: null,
  saving: false,
}

export const reducer = (
  state = initalState,
  action: PagesManagementActionType,
): PagesManagementStore => {
  let page,
    temp,
    companies,
    highestId,
    location,
    my_office,
    call,
    i,
    j,
    pages,
    company

  switch (action.type) {
    case SAVING_PAGES:
      return {
        ...state,
        saving: true,
      }

    case SAVED_PAGES:
      return {
        ...state,
        saving: false,
        companies: state.companies.map(function(company) {
          company.not_saved = false

          company.pages = company.pages.map(function(pag) {
            pag.not_saved = false

            return pag
          })

          return company
        }),
      }
    case REQUEST_COMPANIES:
      return {
        ...state,
        isFetching: true,
      }

    case RECEIVE_COMPANIES: {
      for (i = 0; i < action.companies.length; i++) {
        pages = action.companies[i].pages

        for (j = 0; j < pages.length; j++) {
          pages[j].fields = JSON.parse(pages[j].fields)
          pages[j].integrations = JSON.parse(pages[j].integrations)
          pages[j].preferred_times = pages[j].preferred_times
            ? JSON.parse(pages[j].preferred_times)
            : []
          pages[j].participants = pages[j].participants
            ? pages[j].participants
            : 0
        }
        action.companies[i].pages = pages
      }

      let active_page = null
      let active_tab = null
      if (state.active_company !== null && state.active_page !== null) {
        const oldPage = state.companies
          .find((company) => company.id === state.active_company)
          ?.pages.find((page) => page.id === state.active_page)

        if (oldPage) {
          const newPage = action.companies
            .find((company: Company) => company.id === state.active_company)
            .pages.find((page: MeetingPage) => page.name === oldPage?.name)

          if (newPage === undefined) {
            active_page = null
          } else {
            active_page = newPage.id
          }
        }
      } else {
        if (action.companies.length > 0) {
          active_page = action.companies[0].pages[0].id
          active_tab = 'editor'
        }
      }

      if (active_tab === null) {
        active_tab =
          !state.active_tab || active_page === null ? null : state.active_tab
      }

      return {
        ...state,
        companies: action.companies,
        active_company:
          !state.active_company && action.companies.length > 0
            ? action.companies[0].id
            : state.active_company,
        active_page: active_page,
        active_tab: active_tab,
        isFetching: false,
      }
    }

    case SET_ACTIVE_COMPANY: {
      const first_page_id = state.companies.find(
        (company) => company.id === action.active_company,
      )?.pages[0].id

      return {
        ...state,
        active_company: action.active_company,
        active_page: first_page_id,
        active_tab: first_page_id ? 'editor' : null,
      }
    }

    case SET_ACTIVE_PAGE:
      return {
        ...state,
        active_page: action.active_page,
        active_tab: 'editor',
      }

    case SET_ACTIVE_TAB:
      return {
        ...state,
        active_tab: action.active_tab,
        active_page: action.active_tab === null ? null : state.active_page,
      }

    case SET_LATEST_PAGE:
      return {
        ...state,
      }

    case EDITOR_UPDATE_LOGO:
      page = getPage(state)

      page.avatar = action.logo
      page.logo = action.logo

      return {
        ...state,
        companies: updatePage(state, page),
      }

    case EDITOR_UPDATE_PRIMARY_COLOR:
      page = getPage(state)

      page.colors = {
        primary: action.color,
        secondary: page.colors.secondary,
      }

      return {
        ...state,
        companies: updatePage(state, page),
      }

    case EDITOR_UPDATE_SECONDARY_COLOR:
      page = getPage(state)

      page.colors = {
        primary: page.colors.primary,
        secondary: action.color,
      }

      return {
        ...state,
        companies: updatePage(state, page),
      }

    case EDITOR_UPDATE_LABEL:
      page = getPage(state)

      page.fields = page.fields.map((field) => {
        if (field.id === action.id) {
          field.label = action.label
        }
        return field
      })

      return {
        ...state,
        companies: updatePage(state, page),
      }

    case EDITOR_TOGGLE_REQUIRED:
      page = getPage(state)

      page.fields = page.fields.map(function(field) {
        if (field.id === action.id) {
          field.required = !field.required
        }
        return field
      })

      return {
        ...state,
        companies: updatePage(state, page),
      }

    case EDITOR_UPDATE_COPY:
      page = getPage(state)

      page.copy = {
        page_name: action.copy.page_name
          ? action.copy.page_name
          : page.copy.page_name,
        button:
          typeof action.copy.button !== 'undefined'
            ? action.copy.button
            : page.copy.button,
        tag_line: action.copy.tag_line,
        page_outro:
          action.copy.page_outro !== null
            ? action.copy.page_outro
            : page.copy.page_outro,
      }

      return {
        ...state,
        companies: updatePage(state, page),
      }

    case EDITOR_UPDATE_DURATION_LABEL:
      page = getPage(state)

      page.fields = page.fields.map(function(field) {
        if (field.type === 'duration') {
          field.durations = field.durations?.map(function(duration, index) {
            if (index === action.id) {
              duration.label = action.label
            }
            return duration
          })
        }
        return field
      })

      return {
        ...state,
        companies: updatePage(state, page),
      }

    case EDITOR_UPDATE_DURATION:
      page = getPage(state)

      page.fields = page.fields.map(function(field) {
        if (field.type === 'duration') {
          field.durations = field.durations?.map(function(duration, index) {
            if (index === action.id) {
              duration.duration = action.duration
            }
            return duration
          })
        }
        return field
      })

      return {
        ...state,
        companies: updatePage(state, page),
      }

    case EDITOR_ADD_DURATION:
      page = getPage(state)

      page.fields = page.fields.map(function(field) {
        if (field.type === 'duration' && field.durations) {
          let duration
          if (field.durations.length === 0) {
            duration = {
              label: '15 mins',
              duration: 15,
            }
          } else {
            duration = {
              label:
                field.durations[field.durations.length - 1].duration +
                15 +
                ' mins',
              duration:
                field.durations[field.durations.length - 1].duration + 15,
            }
          }

          field.durations = [...field.durations, duration]
        }
        return field
      })

      return {
        ...state,
        companies: updatePage(state, page),
      }

    case EDITOR_DELETE_DURATION:
      page = getPage(state)

      page.fields = page.fields.map(function(field) {
        if (field.type === 'duration' && field.durations) {
          field.durations = field.durations.filter(function(duration) {
            return duration.duration !== action.id
          })
        }
        return field
      })

      return {
        ...state,
        companies: updatePage(state, page),
      }

    case EDITOR_UPDATE_PLACEHOLDER:
      page = getPage(state)

      page.fields = page.fields.map(function(field) {
        if (field.id === action.id) {
          field.placeholder = action.placeholder
        }
        return field
      })

      return {
        ...state,
        companies: updatePage(state, page),
      }

    case EDITOR_UPDATE_LOCATION:
      page = getPage(state)

      page.fields = page.fields.map(function(field) {
        if (field.id === action.id) {
          field.value = action.location
        }
        return field
      })

      return {
        ...state,
        companies: updatePage(state, page),
      }

    case EDITOR_UPDATE_COPY_VIDEOCALL:
      page = getPage(state)

      page.fields = page.fields.map(function(field) {
        if (field.id === action.id) {
          field.copy = {
            videocall: action.videocall,
            physical: field.copy?.physical,
          }
        }
        return field
      })

      return {
        ...state,
        companies: updatePage(state, page),
      }

    case EDITOR_UPDATE_COPY_PHYSICAL:
      page = getPage(state)

      page.fields = page.fields.map(function(field) {
        if (field.id === action.id) {
          field.copy = {
            physical: action.physical,
            videocall: field.copy?.videocall,
          }
        }
        return field
      })

      return {
        ...state,
        companies: updatePage(state, page),
      }

    case EDITOR_ADD_FIELD: {
      page = getPage(state)
      let field

      highestId = Math.max(...page.fields.map((field) => field.id))

      if (action.form === 'text') {
        field = {
          id: highestId + 1,
          label: 'New Field Label',
          required: false,
          type: MeetingPageFieldType.TEXT,
          value: '',
          placeholder: 'New Field placeholder',
        }
      }

      // TO RELEASE LATER: NEW TYPES
      /**
       if (action.form === "radio") {
        field = {
          id: highestId + 1,
          label: "New radio button Label",
          required: false,
          type: "radio",
          value: "",
          option_1: "",
          option_2: "",
        };
      }

       if (action.form === "number") {
        field = {
          id: highestId + 1,
          label: "New number field Label",
          required: false,
          type: "number",
          value: "",
          default: 0,
        };
      }

       if (action.form === "select") {
        field = {
          id: highestId + 1,
          label: "New dropdown Label",
          required: false,
          type: "select",
          value: "",
          options: [],
        };
      }
       */

      if (field) {
        page.fields = [...page.fields, field]
      }

      return {
        ...state,
        companies: updatePage(state, page),
      }
    }

    case EDITOR_REMOVE_FIELD:
      page = getPage(state)

      page.fields = page.fields.filter(function(field) {
        return field.id !== action.id
      })

      return {
        ...state,
        companies: updatePage(state, page),
      }

    case PAGE_TOGGLE_MY_OFFICE:
      page = getPage(state)

      if (page.location.my_office) {
        my_office = Object.assign({}, page.location.my_office, {
          enabled: page.location.my_office.enabled,
        })
        location = Object.assign({}, page.location, { my_office: my_office })
        page = Object.assign({}, page, { location: location })
      }

      return {
        ...state,
        companies: updatePage(state, page),
      }

    case PAGE_TOGGLE_CALL:
      page = getPage(state)

      if (page.location.call) {
        call = Object.assign({}, page.location.call, {
          enabled: !page.location.call.enabled,
        })
        location = Object.assign({}, page.location, { call: call })
        page = Object.assign({}, page, { location: location })
      }

      return {
        ...state,
        companies: updatePage(state, page),
      }

    case PAGE_TOGGLE_THEIR_OFFICE:
      page = getPage(state)

      if (page.location.their_office) {
        const their_office = Object.assign({}, page.location.their_office, {
          enabled: !page.location.their_office.enabled,
        })
        location = Object.assign({}, page.location, {
          their_office: their_office,
        })
        page = Object.assign({}, page, { location: location })
      }

      return {
        ...state,
        companies: updatePage(state, page),
      }

    case PAGE_ADD_OTHER_OFFICE:
      page = getPage(state)

      if (page.location.my_office) {
        my_office = Object.assign({}, page.location.my_office, {
          locations: [...page.location.my_office.locations, ''],
        })
        location = Object.assign({}, page.location, { my_office: my_office })
        page = Object.assign({}, page, { location: location })
      }

      return {
        ...state,
        companies: updatePage(state, page),
      }

    case PAGE_CHANGE_OFFICE:
      page = getPage(state)

      if (page.location.my_office) {
        my_office = Object.assign({}, page.location.my_office, {
          locations: page.location.my_office.locations.map(function(
            location,
            index,
          ) {
            if (index === action.index) {
              return action.newAddress
            }
            return location
          }),
        })
        location = Object.assign({}, page.location, { my_office: my_office })
        page = Object.assign({}, page, { location: location })
      }

      return {
        ...state,
        companies: updatePage(state, page),
      }

    case PAGE_REMOVE_OFFICE:
      page = getPage(state)

      if (page.location.my_office) {
        my_office = Object.assign({}, page.location.my_office, {
          locations: page.location.my_office.locations.filter(function(
            location,
            index,
          ) {
            return index !== action.index
          }),
        })
        location = Object.assign({}, page.location, { my_office: my_office })
        page = Object.assign({}, page, { location: location })
      }

      return {
        ...state,
        companies: updatePage(state, page),
      }

    case PAGE_ADD_CALL_OPTION:
      page = getPage(state)

      if (page.location.call) {
        call = Object.assign({}, page.location.call, {
          options: [...page.location.call.options, { type: '', value: '' }],
        })
        location = Object.assign({}, page.location, { call: call })
        page = Object.assign({}, page, { location: location })
      }

      return {
        ...state,
        companies: updatePage(state, page),
      }

    case PAGE_CHANGE_CALL_OPTION_TYPE:
      page = getPage(state)

      if (page.location.call) {
        call = Object.assign({}, page.location.call, {
          options: page.location.call.options.map(function(option, index) {
            if (index === action.index) {
              option.type = action.newType
            }
            return option
          }),
        })
        location = Object.assign({}, page.location, { call: call })
        page = Object.assign({}, page, { location: location })
      }

      return {
        ...state,
        companies: updatePage(state, page),
      }

    case PAGE_CHANGE_CALL_OPTION_VALUE:
      page = getPage(state)

      if (page.location.call) {
        call = Object.assign({}, page.location.call, {
          options: page.location.call.options.map(function(option, index) {
            if (index === action.index) {
              option.value = action.newValue
            }
            return option
          }),
        })
        location = Object.assign({}, page.location, { call: call })
        page = Object.assign({}, page, { location: location })
      }

      return {
        ...state,
        companies: updatePage(state, page),
      }

    case PAGE_REMOVE_CALL_OPTION:
      page = getPage(state)

      if (page.location.call) {
        call = Object.assign({}, page.location.call, {
          options: page.location.call.options.filter(function(option, index) {
            return index !== action.index
          }),
        })
        location = Object.assign({}, page.location, { call: call })
        page = Object.assign({}, page, { location: location })
      }

      return {
        ...state,
        companies: updatePage(state, page),
      }

    case PAGE_UPDATE_NAME:
      page = getPage(state)

      page = Object.assign({}, page, { name: action.name })
      page.copy = Object.assign({}, page.copy, { page_name: action.name })

      return {
        ...state,
        companies: updatePage(state, page),
      }

    case EDITOR_UPDATE_DISPLAY_NAME:
      page = getPage(state)

      page = Object.assign({}, page, { display_name: action.display_name })

      return {
        ...state,
        companies: updatePage(state, page),
      }

    case PAGE_UPDATE_PIXEL:
      page = getPage(state)

      page = Object.assign({}, page, { pixel: action.pixel })

      return {
        ...state,
        companies: updatePage(state, page),
      }

    case PAGE_UPDATE_GA:
      page = getPage(state)

      page = Object.assign({}, page, { ga: action.ga })

      return {
        ...state,
        companies: updatePage(state, page),
      }

    case PAGE_UPDATE_CSS:
      page = getPage(state)

      page = Object.assign({}, page, { css: action.css })

      return {
        ...state,
        companies: updatePage(state, page),
      }

    case PAGE_UPDATE_JS:
      page = getPage(state)

      page = Object.assign({}, page, { js: action.js })

      return {
        ...state,
        companies: updatePage(state, page),
      }

    case PAGE_UPDATE_TIMEZONE:
      page = getPage(state)

      page = Object.assign({}, page, { timezone: action.tz })

      return {
        ...state,
        companies: updatePage(state, page),
      }

    case PAGE_UPDATE_PARTICIPANTS:
      page = getPage(state)

      if (action.participants === page.employees.length) {
        page.employees = page.employees.map((employee) => {
          employee.required = true
          return employee
        })
      }

      if (action.participants === 1) {
        page.employees = page.employees.map((employee) => {
          employee.required = false
          return employee
        })
      }

      page = Object.assign({}, page, {
        participants:
          action.participants > page.employees.length
            ? page.employees.length
            : action.participants,
      })

      return {
        ...state,
        companies: updatePage(state, page),
      }

    case PAGE_ADD_EMPLOYEE: {
      page = getPage(state)

      company = state.companies.find((company) => {
        return company.id === state.active_company
      })

      if (company) {
        const employee = company.employees.find((employee) => {
          return employee.id === action.employee
        })

        if (employee) {
          page.employees = [...page.employees, employee]
        }
      }

      return {
        ...state,
        companies: updatePage(state, page),
      }
    }

    case PAGE_SET_REQUIRED_EMPLOYEE:
      page = getPage(state)

      page.employees = page.employees.map((employee) => {
        if (employee.id === action.employee) {
          employee.required = action.required
        }
        return employee
      })

      return {
        ...state,
        companies: updatePage(state, page),
      }

    case PAGE_DELETE_EMPLOYEE:
      page = getPage(state)

      page.employees = page.employees.filter(function(employee) {
        return employee.id !== action.employee
      })

      if (page.participants > 0) {
        page.participants -= 1
      }

      return {
        ...state,
        companies: updatePage(state, page),
      }

    case PAGE_SET_TEMPORARY_START:
      page = getPage(state)

      page = Object.assign({}, page, { start: action.date })

      if (page.end !== undefined && page.end < action.date) {
        temp = new Date(action.date.getTime())
        temp.setDate(temp.getDate() + 1)
        page = Object.assign({}, page, { end: temp })
      }

      return {
        ...state,
        companies: updatePage(state, page),
      }

    case PAGE_SET_TEMPORARY_END:
      page = getPage(state)

      page = Object.assign({}, page, { end: action.date })

      if (page.start !== undefined && page.start > action.date) {
        temp = new Date(action.date.getTime())
        temp.setDate(temp.getDate() - 1)
        page = Object.assign({}, page, { start: temp })
      }

      return {
        ...state,
        companies: updatePage(state, page),
      }

    case PAGE_TOGGLE_AUTO_ACCEPT:
      page = getPage(state)

      page = Object.assign({}, page, {
        auto_accept: !page.auto_accept,
      })

      return {
        ...state,
        companies: updatePage(state, page),
      }

    case PAGE_TOGGLE_ONE_MOMENT:
      page = getPage(state)

      page = Object.assign({}, page, {
        one_moment: !page.one_moment,
      })

      return {
        ...state,
        companies: updatePage(state, page),
      }

    case PAGE_SET_PREFERRED_LANGUAGE:
      page = getPage(state)

      page = Object.assign({}, page, {
        preferred_language: action.language,
      })

      return {
        ...state,
        companies: updatePage(state, page),
      }

    case PAGE_SET_PREFERRED_TIMES:
      page = getPage(state)

      page = Object.assign({}, page, {
        preferred_times: action.preferred_times,
      })

      return {
        ...state,
        companies: updatePage(state, page),
      }

    case PAGE_TOGGLE_SEQUENTIAL:
      page = getPage(state)

      page = Object.assign({}, page, {
        seq: !page.seq,
      })

      return {
        ...state,
        companies: updatePage(state, page),
      }

    case PAGE_SET_BUFFER:
      page = getPage(state)

      page = Object.assign({}, page, {
        buffer: action.buffer,
      })

      return {
        ...state,
        companies: updatePage(state, page),
      }

    case PAGE_SET_FASTEST_POSSIBLE:
      page = getPage(state)

      page = Object.assign({}, page, {
        fastest_possible: action.fastest_possible,
      })

      return {
        ...state,
        companies: updatePage(state, page),
      }

    case PAGE_TOGGLE_IGNORE_CALENDARS:
      page = getPage(state)

      page = Object.assign({}, page, {
        ignore_calendars: !page.ignore_calendars,
      })

      return {
        ...state,
        companies: updatePage(state, page),
      }

    case CHANGE_ACTION: {
      page = getPage(state)
      let actions: IntegrationActions

      const integration = page.integrations.find((integration) => {
        return integration.integration_id === action.integration_id
      })

      if (integration) {
        let isOnRequest = false
        let isOnSchedule = false
        let act = integration.actions.onRequest.find((act) => {
          return act.action_id === action.action_id
        })
        if (act) {
          isOnRequest = true
        } else {
          act = integration.actions.onSchedule.find((act) => {
            return act.action_id === action.action_id
          })
          if (act) {
            isOnSchedule = true
          }
        }

        act = Object.assign({}, act, {
          action_id: action.action_id,
          local_action_id: action.local_action_id,
          value: action.value,
          selected: action.selected,
        })

        if (isOnRequest) {
          const onRequest = integration.actions.onRequest.map(function(a) {
            if (a.action_id === action.action_id) {
              return act
            }
            return a
          })

          actions = Object.assign({}, integration.actions, {
            onRequest: onRequest,
          })
        } else if (isOnSchedule) {
          const onSchedule = integration.actions.onSchedule.map(function(a) {
            if (a.action_id === action.action_id) {
              return act
            }
            return a
          })

          actions = Object.assign({}, integration.actions, {
            onSchedule: onSchedule,
          })
        }

        page.integrations = page.integrations.map(function(integration) {
          if (integration.integration_id === action.integration_id) {
            return Object.assign({}, integration, { actions: actions })
          }
          return integration
        })
      }

      return {
        ...state,
        companies: updatePage(state, page),
      }
    }

    case COMPANY_INFO_UPDATE_NAME:
      companies = state.companies.map(function(company) {
        if (company.id === state.active_company) {
          company = Object.assign({}, company, {
            name: action.name,
            not_saved: true,
          })
        }
        return company
      })
      return {
        ...state,
        companies: companies,
      }

    case COMPANY_SET_AVATAR:
      companies = state.companies.map(function(company) {
        if (company.id === state.active_company) {
          company = Object.assign({}, company, {
            avatar: action.avatar,
            not_saved: true,
          })
        }
        return company
      })
      return {
        ...state,
        companies: companies,
      }

    case COMPANY_ADD_PAGE: {
      let act_pag = state.active_page

      companies = state.companies.map(function(company) {
        company.not_saved = true
        if (company.id === state.active_company) {
          highestId =
            Math.max(...company.pages.map((page) => page.id)) !== -Infinity
              ? Math.max(...company.pages.map((page) => page.id)) + 100000000
              : 100000000

          const employee = company.employees.find((employee: Employee) => {
            return employee.id === action.creator
          })

          if (employee) {
            const newPage: MeetingPage = {
              id: highestId + 1,
              new: true,
              not_saved: true,
              name: 'New Page',
              avatar:
                'https://s3-us-west-2.amazonaws.com/plann3r.profilepictures/default.png',
              logo:
                'https://s3-us-west-2.amazonaws.com/plann3r.profilepictures/default.png',
              employees: [employee],
              preferred_times: [],
              meetingWithOne: true,
              pixel: '',
              ga: '',
              css: '',
              js: '',
              colors: {
                primary: PLANN3R_COLOR,
                secondary: '#4FFAA7',
              },
              copy: {
                page_name: 'New Page',
                button: 'Pick A Moment',
              },
              display_name: '',
              auto_accept: false,
              one_moment: false,
              seq: false,
              buffer: false,
              fastest_possible: false,
              ignore_calendars: false,
              integrations: [],
              participants: 1,
              location: {
                call: {
                  enabled: true,
                  options: [
                    {
                      type: 'videocall',
                      value: '',
                    },
                  ],
                },
                my_office: {
                  enabled: true,
                  locations: [''],
                },
                their_office: {
                  enabled: false,
                },
              },
              timezone: 'Europe/London',
              fields: [
                {
                  id: 1,
                  label: 'Your email address',
                  placeholder: 'someone@company.com',
                  required: true,
                  type: MeetingPageFieldType.EMAIL,
                  value: '',
                },
                {
                  id: 2,
                  label: 'Full name',
                  placeholder: 'Elon Musk',
                  required: true,
                  type: MeetingPageFieldType.NAME,
                  value: '',
                },
                {
                  id: 3,
                  copy: {
                    physical: 'In Person at',
                    videocall: 'VideoCall',
                  },
                  hasLocation: true,
                  hasVirtual: true,
                  label: 'Location',
                  placeholder: '',
                  required: false,
                  selected: 'physical',
                  type: MeetingPageFieldType.LOCATION,
                  value: 'My Office',
                },
                {
                  id: 4,
                  durations: [
                    {
                      label: 'Short meeting',
                      duration: 15,
                    },
                    {
                      label: 'Intake meeting',
                      duration: 30,
                    },
                  ],
                  label: 'Duration',
                  required: true,
                  type: MeetingPageFieldType.DURATION,
                  value: 30,
                },
              ],
            }
            act_pag = newPage.id
            company.pages = [...company.pages, newPage]
          }
        }
        return company
      })
      return {
        ...state,
        companies: companies,
        active_page: act_pag,
        active_tab: 'editor',
      }
    }

    case COMPANY_ADD_EMPLOYEE: {
      let newEmployee

      companies = state.companies.map((company) => {
        if (company.id === state.active_company) {
          highestId = Math.max(...company.employees.map((employee) => employee.id)) !== -Infinity
            ? Math.max(...company.employees.map((employee) => employee.id)) : 0

          newEmployee = {
            id: highestId + 1,
            email: action.employee,
            admin: false,
            confirmed: false,
            first_name: '',
            last_name: '',
            function: '',
            phone_number: '',
            required: true,
            avatar:
              'https://s3-us-west-2.amazonaws.com/plann3r.profilepictures/default.png',
          }
          company.employees = [...company.employees, newEmployee]
          company.not_saved = true
        }

        return company
      })

      return {
        ...state,
        companies: companies,
      }
    }

    case COMPANY_DELETE_EMPLOYEE:
      companies = state.companies.map(function(company) {
        if (company.id === state.active_company) {
          const employees = company.employees.filter(function(employee) {
            return employee.id !== action.id
          })
          company = Object.assign({}, company, {
            employees: employees,
            not_saved: true,
          })
        }
        return company
      })
      return {
        ...state,
        companies: companies,
      }

    case COMPANY_MAKE_ADMIN:
      companies = state.companies.map(function(company) {
        if (company.id === state.active_company) {
          const employees = company.employees.map(function(employee) {
            if (employee.id === action.id) {
              employee = Object.assign({}, employee, {
                admin: true,
                not_saved: true,
              })
            }
            return employee
          })
          company = Object.assign({}, company, {
            employees: employees,
            not_saved: true,
          })
        }
        return company
      })
      return {
        ...state,
        companies: companies,
      }

    default:
      return state
  }
}

const getPage = (state: PagesManagementStore): MeetingPage => {
  const company = state.companies.find(
    (company) => company.id === state.active_company,
  )

  if (company) {
    const page = company.pages.find((page) => page.id === state.active_page)
    if (page !== undefined) return page
  }
  throw Error('Meeting page not found')
}

const updatePage = (state: PagesManagementStore, page: MeetingPage) => {
  return state.companies.map(function(company) {
    if (company.id === state.active_company) {
      company.pages = company.pages.map(function(pag) {
        if (pag.id === state.active_page) {
          pag = page
          page.not_saved = true
        }
        return pag
      })
    }
    return company
  })
}

/*const toggleArray = (array: any[], value: any) => {
  const index = array.indexOf(value)

  if (index === -1) {
    array.push(value)
  } else {
    array.splice(index, 1)
  }

  return array
}*/
